
const SET_LOADING = (state, loading) => {
  state.loading = loading;
};
const SET_PRODUCTS = (state, products) =>{
  state.products = products;
}
const SET_COUNT = (state, count)=>{
  state.count = count;
}
const SET_PAGES = (state, pages)=>{
  state.pages = pages;
}
const SET_PAGE = (state, page)=>{
  state.page = page;
}
const INVALIDATE_LIST = (state) =>{
  state.outDated=true;
}
const SET_INVENTORY_ID = (state, inventoryId)=>{
  state.inventoryId = inventoryId;
}

const SET_ORDER_BY = (state, orderBy)=>{
  state.orderBy = orderBy;
}

const SET_SORT_ICON = (state, sortIcon)=>{
  state.sort_icon = sortIcon;
}

const SET_SEARCH_TERMS = (state, searchTerms)=>{
  state.searchTerms = searchTerms
}
const SET_SELECTED_INDEX = (state, selectedIndex)=>{
  state.selectedIndex=selectedIndex;
}
const SET_SELECTED_PRODUCT = (state, selectedProduct)=>{
  state.selectedProduct = selectedProduct;
}

const SET_LOADING_SELECTED_PRODUCT_ITEMS = (state, loadingSelectedProductItems)=>{
  state.loadingSelectedProductItems=loadingSelectedProductItems;
}
const SET_LOADING_SELECTED_PRODUCT_PURCHASE_ORDERS = (state, loadingSelectedProductPO)=>{
  state.loadingSelectedProductPurchaseOrders=loadingSelectedProductPO;
}
const SET_SELECTED_PRODUCT_ITEMS = (state, selectedProductItems)=>{
  state.selectedProductItems = selectedProductItems;
}
const SET_SELECTED_PRODUCT_PURCHASE_ORDERS = (state, selectedProductPurchaseOrders)=>{
  state.selecteProductPurchaseOrders=selectedProductPurchaseOrders;
}

const UPDATE_SELECTED_PRODUCT = (state, product)=>{
  // let productConverted = null;
  // productConverted = _.cloneDeep(product.quantities[0]);
  // productConverted.product = _.cloneDeep(product);
  // Object.assign(state.products[state.selectedIndex], productConverted);
  // Object.assign(state.selectedProduct, productConverted);
  // state.seletecProduct = state.products[state.selectedIndex];
  Object.assign(state.selectedProduct, product);
}

const SET_LOADING_SELECTED_PRODUCT = (state, loadingSelectedProduct)=>{
  state.loadingSelectedProduct = loadingSelectedProduct;
}

const SET_INVENTORY = (state, inventory)=>{
  state.inventory = inventory;
}

const SET_GLOBAL_INVENTORY_REPORT_LOADING = (state, globalInventoryReportLoading)=>{
  state.globalInventoryReportLoading=globalInventoryReportLoading;
}

const UPDATE_PRODUCTS = (state, products)=>{
  state.products.push(...products);
}

const SET_MODE = (state, mode)=>{
  state.mode = mode;
}

const SET_CHECKED_TAGS = (state, tags)=>{
  state.filters.checkedTags = tags;
}

const SET_PRODUCT_WITH_QUANTITY= (state, productWithQuantity)=>{
  state.filters.productWithQuantity = productWithQuantity;
}

const SET_PRODUCT_IN_SUPPLY= (state, productInSupply)=>{
  state.filters.productInSupply = productInSupply;
}

const RESET_FILTERS = (state)=>{
  state.filters.productWithQuantity = null;
  state.filters.productInSupply = null;
  state.filters.providerId = null;
  state.filters.checkedTags = [];
  state.filters.productPublishedInd = null;
  state.filters.cmsProductPublishedInd = null;
}

const SET_COLUMNS = (state, columns) => {
  state.columns = columns;
  if (localStorage.productListPreferences != null) {
    let preferences = JSON.parse(localStorage.productListPreferences);
    preferences.columns = [];
    _.forEach(columns, c => preferences.columns.push(c));
    localStorage.productListPreferences = JSON.stringify(preferences);
  }

}

const SET_PRODUCT_PUBLISHED_IND = (state, ind) => {
  state.filters.productPublishedInd = ind;
}



export default {
  SET_COLUMNS,
  SET_LOADING,
  SET_PRODUCTS,
  SET_COUNT,
  SET_PAGES,
  SET_PAGE,
  SET_INVENTORY,
  SET_INVENTORY_ID,
  INVALIDATE_LIST,
  SET_ORDER_BY,
  SET_SORT_ICON,
  SET_SEARCH_TERMS,
  SET_SELECTED_INDEX,
  SET_SELECTED_PRODUCT,
  SET_LOADING_SELECTED_PRODUCT_ITEMS,
  SET_LOADING_SELECTED_PRODUCT_PURCHASE_ORDERS,
  SET_SELECTED_PRODUCT_ITEMS,
  SET_SELECTED_PRODUCT_PURCHASE_ORDERS,
  UPDATE_SELECTED_PRODUCT,
  SET_GLOBAL_INVENTORY_REPORT_LOADING,
  SET_LOADING_SELECTED_PRODUCT,
  UPDATE_PRODUCTS,
  SET_MODE,
  SET_CHECKED_TAGS,
  RESET_FILTERS,
  SET_PRODUCT_WITH_QUANTITY,
  SET_PRODUCT_IN_SUPPLY,
  SET_PRODUCT_PUBLISHED_IND,
};
